import { Trans, useTranslation } from "@tecma/i18n";
import { memo } from "react";
import { currencyFormatter } from "utils/currency";

import "./price-section.scss";
import { Button } from "@tecma/ds";

interface PriceSectionProps {
  price: number;
  startDate?: string;
  endDate?: string;
}

export const PriceSection = ({
  price,
  startDate = "1 Gen 24",
  endDate = "1 Gen 28",
}: PriceSectionProps) => {
  const { t } = useTranslation();
  const formattedPrice = currencyFormatter(price || 0, "EUR", {
    style: "decimal",
    maximumFractionDigits: 2,
  });
  return (
    <div className='price-section'>
      <span className='price'>
        <Trans
          i18nKey='card-rooms.feature.price'
          values={{
            count: formattedPrice,
          }}
        />
        <span className='per-month'>{t("card-rooms.feature.per-month")}</span>
      </span>
      <div>
        <span>{startDate}</span> - <span>{endDate}</span>
      </div>
      <div>
        <Button fluid color='primary' onClick={() => {}}>
          {t("card-rooms.highlighted-content.dream.firstButton")}
        </Button>
      </div>
    </div>
  );
};

export default memo(PriceSection);
